var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Card from 'antd/lib/card';
import Col from 'antd/lib/grid/col';
import Icon from 'antd/lib/icon';
import Row from 'antd/lib/grid/row';
import 'antd/lib/card/style/index.css';
import 'antd/lib/grid/style/index.css';
import ListTeam from './ListTeam';
import ListTeamFilter from './ListTeamFilter';
import Page from '../../templates/Page';
import ButtonAction from '../../components/utilities/ButtonAction';
var ListTeamPage = (function (_super) {
    __extends(ListTeamPage, _super);
    function ListTeamPage(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            teams: _this.props.store.teams,
        };
        _this.setFilters = _this.setFilters.bind(_this);
        _this.filterTeams = _this.filterTeams.bind(_this);
        return _this;
    }
    ListTeamPage.prototype.componentWillReceiveProps = function (nextProps) {
        var prevTeams = this.props.store.teams;
        var nextTeams = nextProps.store.teams;
        if ((!prevTeams && nextTeams) ||
            (prevTeams && nextTeams && prevTeams.length !== nextTeams.length)) {
            this.setState({ teams: this.filterTeams(this.state, nextProps.store.teams) });
        }
    };
    ListTeamPage.prototype.setFilters = function (filter) {
        var newFilter = __assign({}, this.state, filter);
        this.setState(__assign({}, newFilter, { teams: this.filterTeams(newFilter) }));
    };
    ListTeamPage.prototype.filterTeams = function (filter, nextTeams) {
        var teams = nextTeams || this.props.store.teams;
        if (filter.filterCategory !== undefined) {
            teams = teams.filter(function (a) { return a.categoryId === filter.filterCategory; });
        }
        if (filter.filterString) {
            var filterString_1 = filter.filterString.toLowerCase();
            teams = teams.filter(function (a) { return (a.name.toLowerCase().indexOf(filterString_1) > -1); });
        }
        return teams;
    };
    ListTeamPage.prototype.render = function () {
        return (React.createElement(Page, { documentTitle: "Teams | " + this.props.store.event.nameShort, pageTitle: 'Teams', pageAction: (React.createElement(ButtonAction, null,
                React.createElement(Link, { to: "/event/" + this.props.store.event.subdomain + "/teams/new" },
                    React.createElement(Icon, { type: 'file-add' }),
                    " Add team"))) },
            React.createElement(Row, { gutter: 24 },
                React.createElement(Col, { xs: 24, md: 24 },
                    React.createElement(Card, { className: 'tableCard' },
                        React.createElement(ListTeamFilter, { categories: this.props.store.categories, setFilters: this.setFilters }),
                        React.createElement(ListTeam, { event: this.props.store.event, categories: this.props.store.categories, teams: this.state.teams }))))));
    };
    return ListTeamPage;
}(React.Component));
var mapStateToProps = function (state) { return ({
    store: {
        user: state.workspaceMain.user && state.workspaceMain.user.data[0],
        event: state.workspaceEvent.event && state.workspaceEvent.event.data[0],
        categories: state.workspaceEvent.categories && state.workspaceEvent.categories.data,
        teams: state.workspaceEvent.teams && state.workspaceEvent.teams.data,
    },
}); };
export default connect(mapStateToProps)(ListTeamPage);



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/ListTeamPage/index.tsx
// module id = 1089
// module chunks = 0